import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  defaultPath: '1',
  currentPath: null,
  previousPath: null,
  branchName: null,
};

export const commonReduxSlice = createSlice({
  name: 'common',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setLinkPath: (state, { payload }) => {
      state.previousPath = payload.previousPath;
      state.currentPath = payload.currentPath;
    },
    setBrName: (state, { payload }) => {
      state.branchName = payload;
    },
  },
});

export const { setLinkPath, setBrName } = commonReduxSlice.actions;


export function setLink(prepath, curpath) {

  return async (dispatch) => {
    let data = { previousPath: prepath, currentPath: curpath }
    //console.log(data)
    dispatch(setLinkPath(data));
  }
}

export function setBranchName(br) {

  return async (dispatch) => {
    dispatch(setBrName(br));
  }
}

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of

export const commonSelector = (state) => state.common;


export default commonReduxSlice.reducer;
